import makeStyles from '@mui/styles/makeStyles'
import { Theme } from '@mui/material'
import createStyles from '@mui/styles/createStyles'

export const useChatEntryColorStyles = makeStyles((theme: Theme) =>
  createStyles({
    msgColorDwrf: {
      color: theme.palette.mode === 'dark' ? '#b97a57' : '#503121',
      borderColor: theme.palette.mode === 'dark' ? '#b97a57' : '#503121',
    },
    msgColorGnom: {
      color: theme.palette.mode === 'dark' ? '#c8bfe7' : '#594497',
      borderColor: theme.palette.mode === 'dark' ? '#c8bfe7' : '#594497',
    },
    msgColorShap: {
      color: theme.palette.mode === 'dark' ? '#d1a5a5' : '#804040',
      borderColor: theme.palette.mode === 'dark' ? '#d1a5a5' : '#804040',
    },
    msgColorMorh: {
      color: theme.palette.mode === 'dark' ? '#83caff' : '#1a9dff',
      borderColor: theme.palette.mode === 'dark' ? '#83caff' : '#1a9dff',
    },
    msgColorHum: {
      color: theme.palette.mode === 'dark' ? '#ffcc00' : '#f29200',
      borderColor: theme.palette.mode === 'dark' ? '#ffcc00' : '#f29200',
    },
    msgColorElf: {
      color: theme.palette.mode === 'dark' ? '#ccff99' : '#00d988',
      borderColor: theme.palette.mode === 'dark' ? '#ccff99' : '#00d988',
    },
    msgColorOrc: {
      color: theme.palette.mode === 'dark' ? '#66cc00' : '#458a00',
      borderColor: theme.palette.mode === 'dark' ? '#66cc00' : '#458a00',
    },
    msgColorGold: {
      color: theme.palette.mode === 'dark' ? '#b8860b' : '#ffd700',
      borderColor: theme.palette.mode === 'dark' ? '#b8860b' : '#ffd700',
    },
    msgColorSilver: {
      color: theme.palette.mode === 'dark' ? '#c0c0c0' : '#696969',
      borderColor: theme.palette.mode === 'dark' ? '#c0c0c0' : '#696969',
    },
    msgColorRed: {
      color: theme.palette.mode === 'dark' ? '#ff3b3b' : '#ff0000',
      borderColor: theme.palette.mode === 'dark' ? '#ff3b3b' : '#ff0000',
    },
  })
)
